import * as React from 'react';
const SvgPoi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M8.362 7.334a.58.58 0 0 0-.821-.009A6.58 6.58 0 0 0 5.6 12c0 1.898.8 3.608 2.083 4.812a.58.58 0 0 0 .808-.02.62.62 0 0 0-.022-.888A5.38 5.38 0 0 1 6.799 12c0-1.477.593-2.816 1.555-3.79a.623.623 0 0 0 .008-.876m1.41 1.409a.57.57 0 0 0-.808-.013A4.59 4.59 0 0 0 7.6 12c0 1.353.584 2.57 1.514 3.411a.57.57 0 0 0 .787-.03c.262-.262.213-.675-.033-.907A3.4 3.4 0 0 1 8.8 12c0-.92.365-1.755.96-2.368.229-.236.266-.634.011-.89m4.456 0a.57.57 0 0 1 .807-.013A4.59 4.59 0 0 1 16.4 12c0 1.353-.585 2.57-1.515 3.411a.57.57 0 0 1-.786-.03c-.263-.262-.213-.675.033-.907A3.4 3.4 0 0 0 15.2 12c0-.92-.366-1.755-.96-2.368-.23-.236-.266-.634-.012-.89m1.41-1.41a.58.58 0 0 1 .82-.008A6.58 6.58 0 0 1 18.4 12a6.58 6.58 0 0 1-2.083 4.812.58.58 0 0 1-.808-.02.62.62 0 0 1 .021-.888A5.38 5.38 0 0 0 17.2 12a5.38 5.38 0 0 0-1.554-3.79.62.62 0 0 1-.009-.876M12 10.8a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4"
    />
  </svg>
);
export default SvgPoi;
